const restoreImageAttribute = (element, attribute) => {
    const deferredAttribute = 'data-menu-' + attribute;
    const value = element.getAttribute(deferredAttribute);
    if (value) {
        element.setAttribute(attribute, value);
    }
    element.removeAttribute(deferredAttribute);
};

export const loadVisibleMenuImages = (container) => {
    if (!container || container.getClientRects().length === 0) {
        return;
    }

    container.querySelectorAll('img[data-menu-src], img[data-menu-srcset]').forEach(image => {
        if (image.getClientRects().length === 0) {
            return;
        }

        image.loading = 'eager';
        const picture = image.closest('picture');
        if (picture) {
            picture.querySelectorAll('source[data-menu-srcset]').forEach(source => {
                restoreImageAttribute(source, 'srcset');
            });
        }
        restoreImageAttribute(image, 'srcset');
        restoreImageAttribute(image, 'src');
    });
};

export const loadOpenMenuImages = () => {
    document.querySelectorAll('.header-menu__menu-checkbox--has-val:checked').forEach(input => {
        loadVisibleMenuImages(input.parentElement.querySelector('.header-menu__sub-menu-container'));
    });
    document.querySelectorAll('.mobile-header-menu__burger-checkbox:checked').forEach(input => {
        loadVisibleMenuImages(input.parentElement.querySelector('.mobile-header-menu__bg'));
    });
};

const showSubMenuBasedOnRadioSelection = (selectedRadio) => {
    const selectedValue = selectedRadio.value;
    // Navigate up to the nearest .header-menu__sub-menu-container parent
    const subMenuContainer = selectedRadio.closest('.header-sub-menu__container');
    const selectedSubMenu = subMenuContainer.querySelector('.header-sub-menu__container[data-active-when="' + selectedValue + '"]');
    if (!selectedSubMenu) {
        return;
    }
    selectedSubMenu.classList.add('header-sub-menu__container--active');
    // Hide other sub-menu containers
    const otherContainers = subMenuContainer.querySelectorAll(':scope > .header-sub-menu__right > .header-sub-menu__container');
    otherContainers.forEach(container => {
        if (container !== selectedSubMenu) {
            container.classList.remove('header-sub-menu__container--active');
        }
    });
};

export default function initializeMegaMenu() {
    const subMenuRadios = document.querySelectorAll('.header-sub-menu__link-radio');
    subMenuRadios.forEach(radio => {
        radio.addEventListener('change', (event) => {
            showSubMenuBasedOnRadioSelection(event.target);
        });
    });
    const backButtons = document.querySelectorAll('.header-sub-menu__back-button');
    backButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            // find the closest .header-sub-menu__container parent and then find the .header-sub-menu__mobile-link-radio--off within it and check it
            const offRadio = event.target.parentElement.parentElement.querySelector('.header-sub-menu__mobile-link-radio--off');
            if (!offRadio) {
                console.error('Back button is not inside a .header-sub-menu__container');
                return;
            }
            offRadio.checked = true;
            loadOpenMenuImages();
        });
    });
    document.querySelectorAll('.header-menu__background, .header-menu__close-icon').forEach(background => {
        background.addEventListener('click', () => {
            document.querySelector('#header-menu__menu-off').checked = true;
        });
    });
    document.querySelectorAll('.header-menu__container').forEach(header => {
        header.addEventListener('change', event => {
            if (event.target.matches('.header-menu__menu-checkbox, .header-sub-menu__link-radio, .header-sub-menu__mobile-link-radio, .mobile-header-menu__burger-checkbox')) {
                loadOpenMenuImages();
            }
        });
    });
    window.addEventListener('pageshow', loadOpenMenuImages);
    window.matchMedia('(min-width: 992px)').addEventListener('change', loadOpenMenuImages);
    loadOpenMenuImages();
};
